var map = {
	"./accountant-area/index.js": 934,
	"./billing/index.js": 941,
	"./forbidden/index.js": 943,
	"./generic-error/index.js": 947,
	"./history/index.js": 963,
	"./home/index.js": 981,
	"./loader/index.jsx": 508,
	"./login/index.js": 985,
	"./management/index.js": 1009,
	"./my-account/index.js": 1054,
	"./not-found/index.js": 1056,
	"./password-recovery/index.js": 1059,
	"./pos/index.jsx": 1063,
	"./registration/index.js": 1212,
	"./sign-up/index.js": 1347,
	"./support/index.js": 1360
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2732;


//////////////////
// WEBPACK FOOTER
// ./src/components/app \.\/[^\/]+\/index\.jsx?$
// module id = 2732
// module chunks = 0